import { render, staticRenderFns } from "./转出项目商品详细_获嘉版本.vue?vue&type=template&id=3879b0b2&scoped=true"
import script from "./转出项目商品详细_获嘉版本.vue?vue&type=script&lang=js"
export * from "./转出项目商品详细_获嘉版本.vue?vue&type=script&lang=js"
import style0 from "./转出项目商品详细_获嘉版本.vue?vue&type=style&index=0&id=3879b0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879b0b2",
  null
  
)

export default component.exports